import { Grid, Space } from 'antd'
import { SizeType } from 'antd/lib/config-provider/SizeContext'
import { MenuProps } from 'antd/lib/menu'
import { MemberProps } from 'app/components/Core/convention'
import Button from 'app/components/UI-Elements/General/Button'
import KDropdown from 'app/components/UI-Elements/Navigation/KDropdown'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

type Props = {
  size?: SizeType
}

const Actions: React.FC<MemberProps<IRental, Props>> = ({ member, props: { size } = {} }) => {
  const { tButtonTitle } = ToolBox.useString()
  const navigate = useNavigate()
  const primaryAction = member.status_info.actions[0]
  const otherActions = member.status_info.actions.slice(1)
  const screens = Grid.useBreakpoint()

  const hideAction = () => {
    return member.status === 'open_invoice' && !screens.md
  }

  const onClick = (e: React.MouseEvent<HTMLElement, MouseEvent>): void => {
    e.stopPropagation()
    navigate(primaryAction.path)
  }

  const onMenuClick: MenuProps['onClick'] = (event) => {
    event.domEvent?.stopPropagation?.()
    navigate(String(event.key))
  }

  const onDropdownClick = (e: React.MouseEvent<HTMLElement, MouseEvent>): void => {
    e.stopPropagation()
  }

  return (
    <Space wrap direction="horizontal">
      <If condition={primaryAction}>
        <Button
          id={`${primaryAction.text}-state`}
          size={size}
          onClick={onClick}
          hidden={hideAction()}
          title={primaryAction.text}
          type="primary"
        />
      </If>
      <If condition={otherActions.length}>
        <KDropdown
          onMenuClick={onMenuClick}
          options={otherActions.map((action) => ({ label: action.text, key: action.path }))}
          buttonProps={{
            size,
            onClick: onDropdownClick,
            title: tButtonTitle({
              recordType: RecordType.rental,
              action: 'other_options'
            })
          }}
        />
      </If>
    </Space>
  )
}

export default Actions
